import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { format } from "@formkit/tempo";
import type { ConversationWindow } from "@/lib/query/conversation/conversation.types";

interface ConversationWindowOpenedIndicatorProps {
  window: ConversationWindow;
}

export function ConversationWindowOpenedIndicator({
  window,
}: ConversationWindowOpenedIndicatorProps) {
  const { t } = useTranslation();

  const closingTime = useMemo(() => {
    try {
      const closingDate = new Date(Date.now() + window.timeRemainingSeconds * 1000);
      return format(closingDate, "HH:mm");
    } catch {
      return "";
    }
  }, [window.timeRemainingSeconds]);

  return (
    <div className="relative my-3 flex items-center">
      {/* Left horizontal line */}
      <div className="h-px flex-1 bg-bordercolor-primary" />

      {/* Center indicator pill */}
      <div className="mx-2 flex items-center gap-1.5 rounded-lg border border-bordercolor-primary bg-green-50 px-3 py-1.5">
        <span className="text-xs font-medium text-green-700">
          {t("common:misc.windowClosesAt", "Venster sluit om")} {closingTime}
        </span>
        <span className="size-2 rounded-full bg-green-500" />
      </div>

      {/* Right horizontal line */}
      <div className="h-px flex-1 bg-bordercolor-primary" />
    </div>
  );
}
